import React from "react";
import Select from "react-select";
import { optionsBranch } from "../../data/branch-data";
import Modal from "react-modal";
import { useForm, Controller } from "react-hook-form";

const ModalCrudCompany2 = ({ modalIsOpen, setIsOpen }) => {
  const { register, control, watch } = useForm();

  const customStyles = {
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      marginRight: "-50%",
      transform: "translate(-50%, -50%)",
      zIndex: "1000",
      maxWidth: "800px",
      maxHeight: "80vh",
    },
    overlay: {
      zIndex: "1000",
    },
  };

  let subtitle;
  //   const [modalIsOpen, setIsOpen] = React.useState(false);

  function openModal() {
    setIsOpen(true);
  }

  function afterOpenModal() {
    // references are now sync'd and can be accessed.
    subtitle.style.color = "#f00";
  }

  function closeModal() {
    setIsOpen(false);
  }

  const displayBody = (
    <div>
      <h2 className="mb-4">เพิ่มสถานประกอบการ</h2>
      <div className="row g-3">
        <div className="col-md-2">ชื่อสถานประกอบการ</div>
        <div className="col-md-10">
          <input
            type="text"
            className="form-control "
            {...register("cp_name")}
          />
        </div>

        <div className="col-md-2">ที่อยู่</div>
        <div className="col-md-4">
          <input
            type="text"
            className="form-control "
            {...register("cp_address")}
          />
        </div>
        <div className="col-md-2">ถนน</div>
        <div className="col-md-4">
          <input
            type="text"
            className="form-control "
            {...register("cp_road")}
          />
        </div>
        <div className="col-md-2">ตำบล</div>
        <div className="col-md-4">
          <input
            type="text"
            className="form-control "
            {...register("cp_subdistrict")}
          />
        </div>
        <div className="col-md-2">อำเภอ</div>
        <div className="col-md-4">
          <input
            type="text"
            className="form-control "
            {...register("cp_district")}
          />
        </div>
        <div className="col-md-2">จังหวัด</div>
        <div className="col-md-4">
          <input
            type="text"
            className="form-control "
            {...register("cp_province")}
          />
        </div>
        <div className="col-md-2">รหัสไปรษณีย์</div>
        <div className="col-md-4">
          <input
            type="number"
            className="form-control "
            {...register("cp_zip")}
          />
        </div>

        <div className="col-md-2">เบอร์โทร</div>
        <div className="col-md-4">
          <input
            type="number"
            className="form-control "
            {...register("cp_tel")}
          />
        </div>
        <div className="col-md-2">อีเมล</div>
        <div className="col-md-4">
          <input
            type="email"
            className="form-control "
            {...register("cp_email")}
          />
        </div>
        <div className="col-md-2">สาขาที่เกี่ยวข้อง</div>
        <div className="col-md-10">
          <Controller
            name="cp_branch_raw"
            control={control}
            render={({ field }) => {
              return <Select options={optionsBranch} isMulti {...field} />;
            }}
          />
          <input
            className="form-control d-none"
            type="text"
            {...register("cp_branch")}
            value={watch("cp_branch_raw")
              ?.map((el) => el.label)
              .join(",")}
          />
        </div>
      </div>
    </div>
  );

  return (
    <div>
      <div>
        {/* <div onClick={openModal}>Open Modal</div> */}

        <Modal
          isOpen={modalIsOpen}
          onAfterOpen={afterOpenModal}
          onRequestClose={closeModal}
          style={customStyles}
        >
          <form action="./add-new-company.php" method="post">
            {displayBody}

            <div className="mt-4 d-flex justify-content-end">
              <div className="btn btn-secondary me-2" onClick={closeModal}>
                Close
              </div>
              <button type="submit" className="btn btn-primary">
                Submit
              </button>
            </div>
          </form>
        </Modal>
      </div>
    </div>
  );
};

export default ModalCrudCompany2;
